import PropTypes from 'prop-types';
import React from 'react';
import { generatePath, Link } from 'react-router-dom';

import './PatientProfileLinkStyles.scss';
import { clinicalSummaryRoute, editPatientRoute, referralManagerRoute } from 'App/common/routeLookup';
import PatientProfileNotes from 'App/components/PatientProfileNotes/PatientProfileNotes';
import PatientAttachments from 'App/components/PatientAttachments';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';

const propTypes = {
    id: PropTypes.string.isRequired,
};
const defaultProps = {};
const PatientProfileLinks = ({ id }) => {
    const hasReferralEnabled = useIsPermitted(PERMISSION_TYPES.ENABLE_REFERRAL);

    return (
        <nav className="profile-actions">
            <ul className="list-inline">
                <li className="list-inline-item">
                    <Link to={generatePath(editPatientRoute, { patientId: id })}>Edit</Link>
                </li>
                <li className="list-inline-item">
                    <Link to={`${clinicalSummaryRoute}?patient_id=${id}&=`}>View Patient Summary</Link>
                </li>
                <li className="list-inline-item">
                    <PatientAttachments patientId={id} />
                </li>
                <li className="list-inline-item">
                    <PatientProfileNotes patientId={id} />
                </li>
                {hasReferralEnabled && (
                    <li className="list-inline-item">
                        <Link to={generatePath(referralManagerRoute, { patientId: id })}>Referral Manager</Link>
                    </li>
                )}
            </ul>
        </nav>
    );
};

PatientProfileLinks.propTypes = propTypes;
PatientProfileLinks.defaultProps = defaultProps;

export default PatientProfileLinks;
